if (!window.customElements.get('friends-mobile-menu')) {
  class FriendsMobileMenu extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-menu-panel]'));
      this.rootPanel = this.querySelector('[data-menu-root]');
      this.history = [];
      this.drawer = this.closest('mobile-navigation');
      this.boundHandleClick = this.boundHandleClick || this.handleClick.bind(this);
      this.boundReset = this.boundReset || this.reset.bind(this);

      this.addEventListener('click', this.boundHandleClick);
      this.drawer?.addEventListener('mobile-nav:close', this.boundReset);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundHandleClick);
      this.drawer?.removeEventListener('mobile-nav:close', this.boundReset);
    }

    handleClick(event) {
      const forwardButton = event.target.closest('[data-menu-target]');
      const backButton = event.target.closest('[data-menu-back]');

      if (forwardButton && this.contains(forwardButton)) {
        this.openPanel(forwardButton.getAttribute('data-menu-target'), forwardButton);
      } else if (backButton && this.contains(backButton)) {
        this.goBack();
      }
    }

    get activePanel() {
      return this.querySelector('[data-menu-panel].is-active');
    }

    openPanel(panelId, trigger) {
      const target = document.getElementById(panelId);

      if (!target || !this.contains(target) || target === this.activePanel) {
        return;
      }

      if (this.activePanel) {
        this.history.push({ panel: this.activePanel, trigger });
        this.hidePanel(this.activePanel);
      }

      trigger.setAttribute('aria-expanded', 'true');
      this.showPanel(target, 'forward');
    }

    goBack() {
      const previous = this.history.pop();

      if (!previous) {
        return;
      }

      this.hidePanel(this.activePanel);
      previous.trigger.setAttribute('aria-expanded', 'false');
      this.showPanel(previous.panel, 'back', false);
      previous.trigger.focus({ preventScroll: true });
    }

    showPanel(panel, transition, moveFocus = true) {
      panel.hidden = false;
      panel.dataset.transition = transition;
      panel.classList.add('is-active');
      this.resetPanelScroll(panel);

      if (moveFocus) {
        const focusTarget = panel.querySelector('[data-panel-focus], a, button');
        focusTarget?.focus({ preventScroll: true });
      }
    }

    hidePanel(panel) {
      if (!panel) {
        return;
      }

      panel.classList.remove('is-active');
      panel.hidden = true;
    }

    resetPanelScroll(panel) {
      const scrollContainer = panel?.querySelector('.friends-mobile-menu__body');

      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      }
    }

    reset() {
      this.panels.forEach((panel) => this.hidePanel(panel));
      this.querySelectorAll('[data-menu-target][aria-expanded="true"]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });

      this.history = [];

      if (this.rootPanel) {
        this.rootPanel.hidden = false;
        this.rootPanel.classList.add('is-active');
        this.rootPanel.dataset.transition = 'forward';
        this.resetPanelScroll(this.rootPanel);
      }
    }
  }

  window.customElements.define('friends-mobile-menu', FriendsMobileMenu);
}
